'use strict';

angular.module('linagora.esn.sync')

  .component('syncMain', {
    template: require('./main.pug'),
    controller: 'syncMainController'
  });
